import React from 'react';
import useCrmRoutes from '../../../hooks/useCrmRoutes';
import List from './List';
import Details from './Details';
import Put from './Put';
import FirmOffice from '../FirmOffice';
import InternalRoutes from '../../../components/_organisms/InternalRoutes';

const Users: React.FC = () => {
  const { isCrmInternalRoute, actualRoute } = useCrmRoutes();

  const routes = [
    {
      component: Put,
      name: 'Firm',
      path: `/crm/${actualRoute}/create`,
      exact: true,
    },
    {
      component: Details,
      name: 'Firm',
      path: `/crm/${actualRoute}/:id`,
      exact: true,
    },
    {
      component: Put,
      name: 'Firm',
      path: `/crm/${actualRoute}/:id/edit`,
      exact: true,
    },
    {
      component: FirmOffice,
      name: 'Firm Office',
      path: `/crm/${actualRoute}/:firmId/offices`,
    },
  ];

  if (isCrmInternalRoute) {
    return <InternalRoutes routes={routes} />;
  }

  return <List />;
};

export default Users;
